export default "__VITE_ASSET__D57K_u6N__"